import React, { useState } from "react"
import PropTypes from "prop-types"
 import List from "./list"
import Specify from "./specify"
import EnquiryPopup from "./enquiry-popup"
import Accessories from "./accessories"
import { InstantSearch,  Configure } from 'react-instantsearch';
import { liteClient as algoliasearch } from 'algoliasearch/lite';

const credentials = ALGOLIA_CREDENTIALS || null
const searchClient = algoliasearch(credentials.appId, credentials.apiKey);

function View({ activeView, modelName, modelCode,  defaultAccessory,  type }) {
    const [hasShownList, setHasShownList] = useState( false);

    return (<div className="configurator__body">
        {activeView === "specify" ? (
           <InstantSearch 
					searchClient={searchClient} 
					indexName="variations"
                    initialUiState={{
                    variations: {
                    refinementList: {
                        ostendoModelName: modelName,
                        enabled: true,
                        type: type,
                    },
                    },
                }}  
				>
                 <Configure
                    hitsPerPage={1000}
                    maxValuesPerFacet={30}
                    maxFacetHits={30}
                    filters={`ostendoModelName:"${modelName}" AND enabled:true AND type:"${type}"`}
                />
             
                <Specify modelName={modelName} modelCode={modelCode} defaultAccessory={defaultAccessory} />
              
            </InstantSearch>
        ) :
        activeView === "enquiry-popup" ? (
              <InstantSearch 
					searchClient={searchClient} 
					indexName="variations"
                    initialUiState={{
                    variations: {
                    refinementList: {
                        ostendoModelName: modelName,
                        enabled: true,
                    },
                    },
                }}    
				>
                    <Configure
                    hitsPerPage={1000}
                    filters={`ostendoModelName:"${modelName}" AND enabled:true`}
                />
                
                <EnquiryPopup modelName={modelName} modelCode={modelCode} defaultAccessory={defaultAccessory} /> 
            </InstantSearch>
        ): activeView === "list" ? (
              <InstantSearch 
					searchClient={searchClient} 
					indexName="variations"
				>
                 <Configure
                    hitsPerPage={1000}
                    filters={`ostendoModelName:"${modelName}" AND enabled:true AND type:"${type}"`}
                />
                 <List hasShownList={hasShownList} setHasShownList={setHasShownList} modelName={modelName} defaultAccessory={defaultAccessory} modelCode={modelCode} /> 
            </InstantSearch>
        ) : (
           <Accessories /> 
        )}
    </div>)
}
View.propTypes = {
    activeView: PropTypes.string,
	modelName: PropTypes.string,
	modelCode: PropTypes.string,
};
export default View